import axios from "../utils/axios.wrapper";

export const getTables = async () => {
  const { data } = await axios.get("/restaurant-table");
  return data.items || data;
};

export const getActiveTables = async () => {
  const { data } = await axios.get("/restaurant-table/active");
  return data.items || data;
};

export const getInactiveTables = async () => {
  const { data } = await axios.get("/restaurant-table/inactive");
  return data.items || data;
};

export const getTablesByRoomId = async (roomId) => {
  const { data } = await axios.get(`/restaurant-table/room/${roomId}`);
  return data.items || data;
};

export const getTableById = async (id) => {
  const { data } = await axios.get(`/restaurant-table/${id}`);
  return data;
};

export const createTable = async (table) => {
  const { data } = await axios.post("/restaurant-table/create", table);
  return data;
};

export const updateTable = async (id, table) => {
  const { data } = await axios.put(`/restaurant-table/${id}`, table);
  return data;
};

export const softDeleteTable = async (id) => {
  const { data } = await axios.put(`/restaurant-table/${id}/deactivate`);
  return data;
};

export const hardDeleteTable = async (id) => {
  const { data } = await axios.delete(`/restaurant-table/${id}`);
  return data;
};

// --- Occupancy (real-time floor plan) ---
export const occupyTable = async (tableId, { guestCount, statusId, shopId }) => {
  const { data } = await axios.post(`/restaurant-table/${tableId}/occupy`, {
    guestCount,
    statusId,
    shopId,
  });
  return data;
};

export const freeTable = async (tableId, { statusId, shopId }) => {
  const { data } = await axios.post(`/restaurant-table/${tableId}/free`, {
    statusId,
    shopId,
  });
  return data;
};

export const restaurantTableService = {
  getTables,
  getActiveTables,
  getInactiveTables,
  getTablesByRoomId,
  getTableById,
  createTable,
  updateTable,
  softDeleteTable,
  hardDeleteTable,
  occupyTable,
  freeTable,
};